import { render, staticRenderFns } from "./DirectDebitTable.html?vue&type=template&id=8a2df05e&scoped=true&"
import script from "./DirectDebitTable.js?vue&type=script&lang=js&"
export * from "./DirectDebitTable.js?vue&type=script&lang=js&"
import style0 from "./DirectDebitTable.scss?vue&type=style&index=0&id=8a2df05e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2df05e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VPagination,VRow})
